import { GIFT_WRAPPING_KEY } from "@lib/constants/product";
import type { Cart } from "@graphql/generated/types";

/**
 * `totalPrice` is a Money object even at 0, so it cannot tell an emptied cart from a full one.
 * Gift wrapping is added inside checkout, so it can also be the only line left after the
 * products are removed.
 */
export const cartIsEmpty = (cart?: Cart | null): boolean =>
    !(cart?.lineItems ?? []).some((lineItem) => lineItem.productKey !== GIFT_WRAPPING_KEY);
